import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toPlainObject } from 'lodash';

import { lockEbons, resetLock } from '../../../../../../services/ebon/actions';

import * as paymentRequestSelector from '../../../../../../services/account/paymentrequest/request/selector';

import { getMerchantCardUrl } from '../../../../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../../../../utils/htmlUtils';

import {
    CheckboxInputFieldComponent,
    EmailInputFieldComponent,
    FormComponent,
    LegendFieldComponent
} from '../../../../../form';

import './PaymentRequestEbonFormComponent.scss';

const PaymentRequestEbonFormComponent = ({
    selectedPartnerId,
    partner,
    cartAmount,
    setRequestedAmount,
    ebonCart,
    cappingError,
    remainingJackpotAfterPayment,
    setEmail,
    formName,
    i18n,
    i18nCommon,
    user,
    initialValues,
    ebons,
    requestSubmit,
    errorSubmit,
    errorMessage,
    lockFetching,
    createOrderRequest,
    timeoutId,
    history,
    lockEbons,
    resetLock
}) => {
    const hasFreeFacial = ebons.freeFacialValue !== undefined;

    const toMerchantCardUrl = urlParams => {
        resetLock();

        const merchantCardPath = getMerchantCardUrl(
            { id: partner.id, name: partner.name },
            false,
            true
        );
        const url = `${merchantCardPath}${urlParams ? urlParams : ''}`;
        history.push(url);
    };

    const submit = formData => {
        setEmail(formData.email);
        setRequestedAmount(cartAmount);

        const ebonCartBody = {
            lockRequests: ebonCart,
            userId: user.username,
            partnerId: selectedPartnerId,
            fixedFacialValue: !hasFreeFacial
        };

        clearTimeout(timeoutId);

        lockEbons(ebonCartBody, null);
    };

    return (
        <div id="payment-request-ebon-form-container" className="container">
            <FormComponent
                form={formName}
                initialValues={initialValues}
                classNameInputContainer="payment-request-ebon-form"
                onSubmit={submit}
                requestSubmit={lockFetching || requestSubmit || createOrderRequest}
                errorSubmit={errorSubmit}
                submitText={i18n.PAYMENT_REQUEST_FORM.EBON.PAYMENT_REQUEST_EBONS_BUTTON}
                buttonDisabled={cartAmount <= 0 || remainingJackpotAfterPayment < 0}>
                <EmailInputFieldComponent
                    name="email"
                    label={i18n.PAYMENT_REQUEST_FORM.EBON.EMAIL_ADDRESS_CONFIRMATION}
                    placeholder={i18nCommon.PLACEHOLDER_EMAIL}
                    classNameInputContainer="one-half mr50"
                    isRequired
                />

                <CheckboxInputFieldComponent
                    name="confirmEmail"
                    classNameInputContainer="confirmEmail"
                    options={[
                        {
                            label:
                                i18n.PAYMENT_REQUEST_FORM.EBON
                                    .EMAIL_DELIVERY_VALIDATION_CHECKBOX_LABEL_EBON,
                            value: true
                        }
                    ]}
                    minRequired={1}
                />

                <LegendFieldComponent classNameInputContainer="full">
                    {i18nCommon.MANDATORY_FIELD}
                </LegendFieldComponent>

                <React.Fragment>
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </React.Fragment>
                <React.Fragment>
                    {cappingError && (
                        <p className="error-message">
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_REQUEST_FORM.EBON.CAPPING_ERROR_MESSAGE_1
                            )}
                            <span
                                className="fakeLink"
                                onClick={() => toMerchantCardUrl('#conditions')}>
                                {i18n.PAYMENT_REQUEST_FORM.EBON.CAPPING_ERROR_MESSAGE_2}
                            </span>
                            {i18n.PAYMENT_REQUEST_FORM.EBON.CAPPING_ERROR_MESSAGE_3}
                        </p>
                    )}
                </React.Fragment>
            </FormComponent>
        </div>
    );
};

PaymentRequestEbonFormComponent.propTypes = {
    selectedPartnerId: PropTypes.number.isRequired,
    partner: PropTypes.object.isRequired,
    cartAmount: PropTypes.number.isRequired,
    setRequestedAmount: PropTypes.func.isRequired,
    ebonCart: PropTypes.array.isRequired,
    cappingError: PropTypes.bool,
    remainingJackpotAfterPayment: PropTypes.number.isRequired,
    setEmail: PropTypes.func.isRequired,
    formName: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        i18nCommon: state.i18n.feature.form,
        user: user,
        initialValues: {
            email: user.email ? user.email : ''
        },
        ebons: state.ebon.ebons,
        requestSubmit: paymentRequestSelector.isRequesting(state),
        errorSubmit: paymentRequestSelector.isError(state),
        errorMessage: paymentRequestSelector.getError(state),
        lockFetching: state.ebon.lockFetching,
        createOrderRequest: state.ebon.createOrderRequest,
        timeoutId: paymentRequestSelector.getTimeoutId(state)
    };
};

const mapDispatchToProps = {
    lockEbons,
    resetLock
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PaymentRequestEbonFormComponent)
);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/payment-requests/ebon/PaymentRequestEbonFormComponent.js